import Accordion from "@/common/components/Accordion";
import { BookMarkedIcon } from "lucide-react";

const NegotiationHelper = ({ defaultOpen }: { defaultOpen?: boolean; }) => {
  return (
    <Accordion
      triggerClassName="py-2"
      defaultOpen={defaultOpen}
      head={(
        <div className="flex items-center gap-2">
          <BookMarkedIcon strokeWidth={1.5} />

          <p className="text-md font-medium">
            Como funciona a negociação
          </p>
        </div>
      )}
      body={(
        <div className="flex flex-col gap-3 pt-2">
          <p>
            <span className="font-medium">Envie sua proposta de negociação:</span> Descreva sua oferta para o estabelecimento, selecione os produtos e informe o valor desejado.
          </p>
          <p>
            O estabelecimento terá 7 dias para avaliar sua proposta e poderá aceitá-la, recusá-la ou fazer contrapropostas em determinados produtos.
          </p>
          <p>
            Ao receber uma contraproposta você poderá aceitar ou realizar uma nova contraproposta e enviar ao estabelecimento.
          </p>
          <p>
            Caso todas as propostas de negociação forem finalizadas, o estabelecimento definirá o período de vigência, e a negociação será válida pelo prazo estipulado.
          </p>
        </div>
      )}
    />
  );
};

export default NegotiationHelper;
